module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.30225/images/keyFeatures/breeze_actions_workflows.png"